export default __webpack_public_path__ + "static/media/p2023-18.a958e6be.jpeg";